const initialState = () => {
    return {
        color: 'success',
        message: '',
        active: false,
    }
}

export default initialState
